import { renderListBodyFromCommunication } from "./shared";
import { BaseNewlyNotReportingTemplate } from "./baseNewlyNotReportingTemplate";
export class NewlyNotReportingListTemplate extends BaseNewlyNotReportingTemplate {
    /** When set, facility lines include "(ID <value>)" for this alternate ID type when present. */
    getDisplayIdType() {
        return undefined;
    }
    subject(params) {
        return this.buildSubject(params.communication);
    }
    text(params) {
        return renderListBodyFromCommunication(params.communication, {
            displayIdType: this.getDisplayIdType(),
        });
    }
}
//# sourceMappingURL=listTemplate.js.map